import { theme } from '@notino/react-styleguide'
import styled, { css } from 'styled-components'
import ChevronIcon from '../../assets/icons/ChevronRightIcon'
import { truncate } from '../../styles/helpers'

export const OptionIconWrapper = styled.span`
	margin-right: 8px;
	color: ${theme.color.text.primary};
`

export const OptionAddress = styled.div`
	color: ${theme.color.text.tertiary};
	font-size: 14px;
	display: flex;
	align-items: center;
	gap: 4px;
	font-weight: 400;
	flex-wrap: wrap;
`

export const Address = styled.span`
	${truncate};
	b {
		color: ${theme.color.text.primary};
	}
`

export const SalonContent = styled.div`
	min-width: 0;
	overflow: hidden;
	flex: 1;
`

export const SalonName = styled.span`
	font-weight: 500;
	color: ${theme.color.text.tertiary};
	${truncate};
	display: block;
	b {
		color: ${theme.color.text.primary};
	}
`

export const CityName = styled.span<{ $myLocationOption?: boolean }>`
	font-weight: 400;
	color: ${theme.color.text.tertiary};
	${truncate};
	flex: 1;
	min-width: 0;
	b {
		color: ${theme.color.text.primary};
	}
	${({ $myLocationOption }) =>
		$myLocationOption &&
		css`
			color: ${theme.color.text.highlight};
			position: relative;

			&::after {
				display: block;
				position: absolute;
				content: '';
				top: 0;
				left: 0;
				right: 0;
				bottom: -8px;
				border-bottom: 1px solid red;
			}
		`}
`

export const SalonOptionContent = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	min-width: 0;
	overflow: hidden;
`

export const ChevronRightIcon = styled(ChevronIcon)`
	flex-shrink: 0;
`

export const OptionLinkWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`

export const DistanceWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
`

export const OptionContent = styled.div<{ $myLocationOption?: boolean }>`
	display: flex;
	align-items: center;
	min-width: 0;
	overflow: hidden;
`
